import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth/useAuth';

/**
 * Route Guard: Zeigt die LoginPage nur an, wenn user NICHT authentifiziert ist.
 * Bei erfolgreicher Auth wird NUR EINMAL umgeleitet (nicht bei jedem Render).
 */
export function RequireNoAuth({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const nav = useNavigate();
  const didNavigateRef = useRef(false);
  const locked = typeof window !== 'undefined' && localStorage.getItem('mk-admin-locked') === 'true';

  useEffect(() => {
    // Bei lokalem Admin-Lock MUSS die Login-Seite sichtbar bleiben.
    // Sonst entsteht ein Redirect-Loop:
    // /login -> / (RequireNoAuth) -> /login (RequireAuth wegen lock) -> ...
    if (locked) return;

    // Nur einmal navigieren, wenn Benutzer bereits angemeldet ist.
    if (!loading && session && !didNavigateRef.current) {
      didNavigateRef.current = true;
      nav('/', { replace: true });
    }
  }, [session, loading, locked, nav]);

  // Während noch geladen wird, LoginPage rendern
  if (loading) {
    return <>{children}</>;
  }

  // Ohne Lock wird bei Session zur Startseite weitergeleitet.
  if (session && !locked) {
    return null;
  }

  return <>{children}</>;
}
